/**
 * Segmentos estáticos de 1º nível sob `/chatbot`. Precisam ser conhecidos porque
 * `/chatbot/<x>` é ambíguo: `<x>` pode ser um channelId OU uma dessas rotas. Sem a
 * exclusão, abrir `/chatbot/templates` habilitaria os itens de canal apontando pra
 * rotas inexistentes (`/chatbot/templates/kanban_view`).
 *
 * **Rota estática nova sob `/chatbot` PRECISA entrar aqui.** Cada entrada tem teste
 * próprio; a lista já cresceu 4 vezes.
 */
export const STATIC_CHATBOT_SEGMENTS = [
  'contacts',
  'transmission-groups',
  'pools',
  'dispatches',
  'new-conversation',
  'templates',
] as const

/** `channelId` da rota atual, ou `null` fora de um canal. Fonte ÚNICA — o rail e o
 *  toast de atividade precisam concordar sobre o que é "o canal aberto". */
export function channelIdFromPathname(pathname: string): string | null {
  const segment = pathname.match(/^\/chatbot\/([^/]+)/)?.[1] ?? null
  if (!segment) return null
  return STATIC_CHATBOT_SEGMENTS.some((s) => s === segment) ? null : segment
}
